// extracted by mini-css-extract-plugin
export default {"icon":"Whatsapp_icon__sbgeD"};